// store/dashboard/orderDetailsSlice.js
import { createDefaultState, createGenericSlice } from "../createGenericSlice.ts";
import { createAsyncThunk } from "@reduxjs/toolkit";
import ApiManager from "../../api/ApiManager.tsx";
import { BillingAddress, ShippingAddress } from "../user/userSlice.types.ts";
import {
    Product
} from "../../features/Dashboard/features/Orders/components/DetailsOrders/OrderDetailsProductsShared.tsx";

export interface OrderDetails {
    paid: boolean;
    internalNumber: string;
    status: number;
    currency: string;
    price: number;/*{
        net: number;
        gross: number;
        reseller?: {
            net: number;
            gross: number;
        }
    };*/
    deliveryCost: number;
    deliveryType: string;
    paymentType: string;
    deliveryMethod: string;
    products: Product[];
    billingAddress: null | BillingAddress;
    deliveryAddress: null | ShippingAddress;
    additionalInformation: string | null;
    acceptedAt: null | string;
    redirectedToCentral: null | string;
    orderedTime: string;
    seller: null | string;
    proforma: null | string;
    sale: null | string;
    dropshipping: null | boolean;
    options: {
        canManage: boolean;
        canReject: boolean;
        canAddInvoice: boolean;
        canClaimOrder: boolean;
        canRedirectToCentral: boolean;
        canSetDeliveryNumber: boolean;
        canSetPaid: boolean;
        canSetStatus: boolean;
    }
}

export const fetchOrdersDetails =
    createAsyncThunk('orderDetails/fetchOrdersDetails', (orderId: string) => ApiManager.fetchOrdersDetails(orderId));

export const setOrderAsPaid =
    createAsyncThunk('orderDetails/setOrderAsPaid', (orderId: string) => ApiManager.setOrderAsPaid(orderId));

export const setOrderStatus =
    createAsyncThunk('orderDetails/setOrderStatus', ({ orderId, status, email }: {
        orderId: string,
        status: number,
        email?: boolean
    }) => ApiManager.setOrderStatus(orderId, status, email || false));

export const redirectOrderToCentral =
    createAsyncThunk('orderDetails/redirectOrderToCentral', (orderId: string) => ApiManager.redirectOrderToCentral(orderId));


/*interface State extends GenericState<OrderDetails> {
    data: OrderDetails;
}*/

const initialState = createDefaultState<OrderDetails>({
    internalNumber: '',
    status: 0,
    currency: '',
    price: 0,
    deliveryCost: 0,
    deliveryType: '',
    deliveryMethod: '',
    paymentType: '',
    products: [],
    billingAddress: null,
    deliveryAddress: null,
    additionalInformation: null,
    acceptedAt: null,
    redirectedToCentral: null,
    orderedTime: '',
    seller: null,
    proforma: null,
    sale: null,
    paid: false,
    dropshipping: null,
    options: {
        canAddInvoice: false,
        canClaimOrder: false,
        canRedirectToCentral: false,
        canSetDeliveryNumber: false,
        canSetPaid: false,
        canSetStatus: false,
        canManage: false,
        canReject: true,
    }
})

const userSlice = createGenericSlice<OrderDetails>({
    name: 'orderDetails',
    initialState: initialState,
    asyncThunk: fetchOrdersDetails,
});

export default userSlice.reducer;
